<template>
    <v-dialog v-model="dialog" width="700" :fullscreen="isMobileOrTablet()" persistent>
        <v-card class="rounded-lg" style="display: flex; flex-direction: column; height: 100%;">
            <v-card-title style="background-color: #1a5b0f !important; display: flex; justify-content: space-between; align-items: center;">
                <div>
                    <span class="font-weight-bold text-h6 text-white">{{ dialog_title }}</span>
                    <div class="text-caption text-white">{{ dialog_sub_title }}</div>
                </div>
                <v-btn v-if="loading == false" flat icon color="darkGreen" @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
                <v-form ref="form" class="mt-2">
                    <v-row dense>
                        <v-col cols="12">
                            <v-textarea
                                v-model="description"
                                :rules="[formRules.required]"
                                label="Description"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                >
                            </v-textarea>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="hours"
                                label="Hours"
                                variant="outlined"
                                rounded="lg"
                                type="number"
                                color="darkGreen"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="unit"
                                label="Unit"
                                variant="outlined"
                                rounded="lg"
                                type="number"
                                color="darkGreen"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-autocomplete
                                v-model="category"
                                label="Category"
                                variant="outlined"
                                rounded="lg"
                                color="darkGreen"
                                :items="categoryData"
                                item-title="name"
                                item-value="name"
                                >
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-3" style="margin-top: auto;">
                <v-spacer></v-spacer>
                <v-btn class="mr-1" :disabled="loading" text="Cancel" variant="outlined" elevation="1" @click="closeDialog()"></v-btn>
                <v-btn class="mr-1" :loading="loading" text="Save" variant="elevated" elevation="1" color="darkGreen" @click="validateForm()"></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue'
import { useSnackbar } from '@/composables/useSnackbar'

export default defineComponent({
     emits: ["refresh"],
     data(){
        return {
            dialog: false,
            dialog_title: null,
            dialog_sub_title: null,
            action: null,
            loading: false,

            id: null,
            description: null,
            hours: null,
            unit: null,
            category: null,
            user_id: null,
            semester_schoolyear: null,

            categoryData: [
                { name: 'Research' },
                { name: 'Extension' },
                { name: 'Production' },
            ],
        }
     },
     methods: {
        initAdd(data){
            this.dialog = true
            this.dialog_title = 'REP Load Release'
            this.dialog_sub_title = 'Add new rep load release'
            this.action = 'add'

            this.user_id = data.id
            this.semester_schoolyear = this.$store.state.semester_schoolyear.id
        },
        initUpdate(data){
            this.dialog = true
            this.dialog_title = 'REP Load Release'
            this.dialog_sub_title = 'Update rep load release details'
            this.action = 'edit'

            this.id = data.id
            this.description = data.description
            this.hours = data.hours
            this.unit = data.unit
            this.category = data.category
        },
        async validateForm(){
            const { showSnackbar } = useSnackbar()
            const { valid } = await this.$refs.form.validate()

            if(valid){
                this.loading = true
                let formData = {
                    id: this.id,
                    description: this.description,
                    hours: this.hours,
                    unit: this.unit,
                    category: this.category,
                    user_id: this.user_id,
                    semester_schoolyear: this.semester_schoolyear
                }

                const token = localStorage.getItem('aums-token')

                if(this.action == 'add')[
                    axios.post(process.env.VUE_APP_SERVER_URL + '/rep-load', formData,
                    { headers:
                        { 
                            'Authorization': `Bearer ${token}`,
                        }
                    }
                    ).then((res)=>{
                        if(res.data.status == 200){
                            this.loading = false
                            this.$emit('refresh')
                            showSnackbar('Admin Load Release successfully added!')
                            this.$refs.form.reset()
                            this.dialog = false
                        }
                    }).catch((error)=>{
                        if(error.response.status == 401){
                            this.loading = false
                            showSnackbar('Token expired! Logging out..')

                            localStorage.removeItem("vuex");
                            localStorage.removeItem("aums-token");
                            window.location.reload();
                        }
                        else{
                            console.log(error)
                        }
                    })
                ]
                else if(this.action == 'edit'){
                    axios.patch(process.env.VUE_APP_SERVER_URL + '/rep-load/' + this.id, formData,
                    { headers:
                        { 
                            'Authorization': `Bearer ${token}`,
                        }
                    }
                    ).then((res)=>{
                        if(res.data.status == 200){
                            this.loading = false
                            this.$emit('refresh')
                            showSnackbar('REP Load Release successfully updated!')
                            this.$refs.form.reset()
                            this.dialog = false
                        }
                    }).catch((error)=>{
                        if(error.response.status == 401){
                            this.loading = false
                            showSnackbar('Token expired! Logging out..')

                            localStorage.removeItem("vuex");
                            localStorage.removeItem("aums-token");
                            window.location.reload();
                        }
                        else{
                            console.log(error)
                        }
                    })
                }
            }
        },
        closeDialog(){
            this.$refs.form.reset()
            this.dialog = false
        }
     }
})
</script>

<style scoped>

</style>